import useArtistEventDetailsElement from '../../../hooks/artistEvents/useArtistEventDetailsElement';

const ArtistEventDetails = () => useArtistEventDetailsElement();

export default ArtistEventDetails;
